/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_1_ProblemInputs */

const es_home_usecases_item_1_problem = /** @type {(inputs: Home_Usecases_Item_1_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un equipo de ventas necesita encontrar rápidamente el último contrato modificado con un cliente específico entre miles de archivos.`)
};

const en_home_usecases_item_1_problem = /** @type {(inputs: Home_Usecases_Item_1_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sales team needs to quickly find the latest contract modified with a specific client among thousands of files.`)
};

/**
* | output |
* | --- |
* | "A sales team needs to quickly find the latest contract modified with a specific client among thousands of files." |
*
* @param {Home_Usecases_Item_1_ProblemInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_1_problem = /** @type {((inputs?: Home_Usecases_Item_1_ProblemInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_1_ProblemInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_1_problem(inputs)
	return en_home_usecases_item_1_problem(inputs)
});
export { home_usecases_item_1_problem as "home.usecases.item_1_problem" }